import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import VueFormulate from '@braid/vue-formulate'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import moment from 'moment'
import axios from 'axios'
import { VuejsDatatableFactory } from 'vuejs-datatable';
//import VueCryptojs from 'vue-cryptojs'
import Vuex from 'vuex'
import sha3 from 'crypto-js/sha3';
 


import './assets/css/app.css'



Vue.prototype.axios = axios



Vue.prototype.moment = moment
Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use( VuejsDatatableFactory );

import Home from './components/Home'
import Login from './components/Login'
import Logout from './components/Logout'
import Quote from './components/Quote'
import Quotes from './components/Quotes'
import Error from './components/Error'
import QuoteView from './components/QuoteView'

import MyFormulateAutocomplete from './components/MyFormulateAutocomplete'

// register your component with Vue
Vue.component('MyFormulateAutocomplete', MyFormulateAutocomplete)

Vue.use(VueFormulate, {
  library: {
    autocomplete: {
      classification: 'text',
      component: 'MyFormulateAutocomplete'
    }
  }
})

const store = new Vuex.Store({
  state: {
    userJWT: localStorage.userJWT ? localStorage.userJWT : 0
  },
  mutations: {
    setUserJWT(state, jwt){
      state.userJWT = jwt
    }
  }
})


const routes = [
  { path: '/', component: Quotes },
  { name: 'login', path: '/login', component: Login },
  { name: 'error', path: '/error', component: Error },
  { path: '/quote', component: Quote },
  { path: '/logout', component: Logout },
  { path: '/quote/:id', component: Quote },
  { path: '/view/:id', component: QuoteView },
  { name: 'quotes', path: '/quotes', component: Quotes },

  { name: 'duplicateQuote', path: '/quote/duplicate/:duplicateQuoteId', component: Quote },
]

const router = new VueRouter({
  mode: 'history',
  routes // short for `routes: routes`
})

var Mixen = {
  methods: {
     userLoggedIn(){
      if(store.state.userJWT === 0){
        console.log('false')
        return false
      }else{
        console.log('true')
        return true
      }
    },        
    async requiresUserAuth(){
      
      if(this.userLoggedIn()){
        axios
        .get('/api/users/me', {
          headers: {
            Authorization: `Bearer ${store.state.userJWT}`,
          },
        })
        .then(response => {
          
          return true
        
        })
        .catch(error => {
            console.log('An error occurred:', error.response);
            this.handleError(error.response)
        });           
      }else{
        router.push({
          name: 'login',
        })
      }
    },
    async userLogout(){
      localStorage.removeItem('userJWT')
      store.commit('setUserJWT', 0)
      router.push({
          name: 'quotes',
          params: {
              saveSuccess: true,
              message: 'You were logged out'
          }
      })
    },       
    getHashSalt: function(){
      return 'BirthdayFranticSupperViolinPotatoe'
    },
    encrpytQuoteId: function (id) {
      const encryptedId = sha3(id.toString() + this.getHashSalt()).toString()
      return btoa(encryptedId)
    },
    async handleError(errorResponse){
      if(errorResponse.status == 503){
        router.push({
          name: 'error', 
          params: {
            status: errorResponse.status,
            statusText: errorResponse.statusText
          }
        })
      }else if(errorResponse.status == 401){
        router.push({
          name: 'login',
        })
      }
      return
    }
  }
} 

let vm = new Vue({
  mixins: [Mixen],
  router,
  store: store,
  render: h => h(App),
}).$mount('#app')

global.vm = vm; 
